var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$options.name},[(!_vm.token)?_c('layout-default'):_c('in-app')],1)}
var staticRenderFns = []

export { render, staticRenderFns }